import React, { useState } from 'react';

const links: Record<string, string> = {
  one: './images/certifiedMail01.png',
  two: './images/certifiedMail02.png',
};

function CertifiedMail() {
  const [state, setState] = useState<boolean>(false);

  return (
    <div className="flex flex-col h-[calc(100vh-150px)]">
      <img
        className="cursor-pointer"
        src={state ? links.two : links.one}
        alt="certifiedMail"
        onClick={() => setState(!state)}
      />
    </div>
  );
}

export default CertifiedMail;
